<!-- 表1填写 -->

<template>
  <div class="tabCage ssTab1E">
    <div class="tabTtl">
      <span>出版经营情况调查表</span>
      <!-- <div class="tabBtns" style="float: right;">
          <el-button type="primary" size="small" class="importBtn" @click="getCode401HistoryData">导入历史数据</el-button>
        </div> -->
    </div>

    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <!-- <tr>
            <td class="edName">
              连续型电子出版物<br />出版单位（主办单位）<br />具有的出版资质：</td>
            <td class="edInp">
              <el-checkbox disabled v-model="params.qualificationTs" true-label="1" false-label="0"
                label="图书"></el-checkbox>
              <el-checkbox disabled v-model="params.qualificationQk" true-label="1" false-label="0"
                label="期刊"></el-checkbox>
              <el-checkbox disabled v-model="params.qualificationYx" true-label="1" false-label="0"
                label="音像"></el-checkbox>
              <el-checkbox disabled v-model="params.qualificationDz" true-label="1" false-label="0"
                label="电子"></el-checkbox>
              <el-checkbox disabled v-model="params.qualificationWl" true-label="1" false-label="0"
                label="网络"></el-checkbox>
              <el-checkbox disabled v-model="params.qualificationBz" true-label="1" false-label="0"
                label="报纸"></el-checkbox>
            </td>
          </tr> -->

          <!-- <tr>
            <td class="edName">营收高于出版业务<br />的其他主营业务：</td>
            <td class="edInp">
              <el-form-item prop="otherbusiness" :inline-message="true">
                <el-input
                  disabled
                  type="textarea"
                  :rows="3"
                  v-model="params.otherbusiness"
                  placeholder="请输入"
                  size="small"></el-input>
              </el-form-item>
            </td>
          </tr> -->
          <!-- <tr>
            <td class="edName">除传统光盘载体出版外<br />在哪些方面有所拓展：</td>
            <td class="edInp">
              <el-checkbox
                disabled
                v-model="params.expandBusinessMedium"
                true-label="1"
                false-label="0"
                label="新媒体"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessWeb"
                true-label="1"
                false-label="0"
                label="直接通过网络传播的出版物"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessBook"
                true-label="1"
                false-label="0"
                label="图书出版物(此项由盘配书试点单位选填)"></el-checkbox
              ><br />
              <el-checkbox disabled v-model="params.expandBusinessOther" true-label="1" false-label="0" label="其他">
              </el-checkbox>
              <el-input
                disabled
                v-if="params.expandBusinessOther == '1'"
                v-model="params.expandBusinessOtherFill"
                true-label="1"
                false-label="0"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请输入其他"></el-input>
              <br />
              <el-checkbox
                disabled
                v-model="params.expandBusinessEmpty"
                true-label="1"
                false-label="0"
                label="无"></el-checkbox
              ><br />
            </td>
          </tr> -->
          <tr>
            <td class="edName">围绕本连续型电子<br />出版物自行开设并运营<br />的项目：</td>
            <td class="edInp">
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.operationProjectWeb"
                true-label="1"
                false-label="0"
                label="业务网站(数据平台）"></el-checkbox>
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.operationProjectDatabase"
                true-label="1"
                false-label="0"
                label="专业数据库"></el-checkbox>
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.operationProjectWechat"
                true-label="1"
                false-label="0"
                label="微信公众号"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.operationProjectApp"
                true-label="1"
                false-label="0"
                label="小程序或APP"></el-checkbox>
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.operationProjectWeibo"
                true-label="1"
                false-label="0"
                label="微博"></el-checkbox>
              <el-checkbox disabled v-model="params.operationProjectOther" true-label="1" false-label="0" label="其他">
              </el-checkbox>
              <el-input
                disabled
                v-if="params.operationProjectOther == '1'"
                v-model="params.operationProjectOtherFill"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请输入其他"></el-input
              ><br />

              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.operationProjectEmpty"
                true-label="1"
                false-label="0"
                label="无"></el-checkbox>
            </td>
          </tr>

          <tr>
            <td class="edName">
              <!-- 是否与合作方一对一签订数字传播权合同： -->
              获取文章数字传播权主要方式：
            </td>
            <td class="edInp">
              <!-- <el-radio-group v-model="params.rd1">
                <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group> -->
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.getGPLMethodSubmit"
                true-label="1"
                false-label="0"
                label="在期刊刊登声明，投稿即视为授权"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.getGPLMethodTip"
                true-label="1"
                false-label="0"
                label="在投审稿平台予以提示，同意授权方可投稿"></el-checkbox
              ><br />
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.getGPLMethodAuthor"
                true-label="1"
                false-label="0"
                label="与作者签订一对一的数字传播权授权合同"></el-checkbox
              ><br />
              <el-checkbox disabled label="其他" v-model="params.getGPLMethodOther" true-label="1" false-label="0">
              </el-checkbox
              ><br />
              <el-checkbox
                disabled
                class="avgchbox"
                v-model="params.getGPLMethodEmpty"
                true-label="1"
                false-label="0"
                label="无"></el-checkbox>
            </td>
          </tr>

          <tr>
            <td class="edName">数据平台建设和合作情况：</td>
            <td class="edInp">
              <el-radio-group disabled v-model="params.databasePlatformOwner">
                <el-radio :label="'1'">自建</el-radio>
                <el-radio :label="'0'">共建</el-radio>
              </el-radio-group>
              <el-input
                disabled
                v-if="params.databasePlatformOwner == 1"
                v-model="params.databasePlatformName"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请填写平台名称"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">是否与国际出版商开展合作：</td>
            <td class="edInp">
              <el-radio-group disabled v-model="params.internationpublisher">
                <el-radio :label="'1'">是</el-radio>
                <el-radio :label="'0'">否</el-radio>
              </el-radio-group>
              <el-input
                disabled
                v-if="params.internationpublisher == 1"
                v-model="params.internationpublisherName"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请填写合作商名称"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">是否被知名数据库收录：</td>
            <td class="edInp">
              <el-radio-group disabled v-model="params.collectdatabase">
                <el-radio :label="'1'">是</el-radio>
                <el-radio :label="'0'">否</el-radio>
              </el-radio-group>
              <el-input
                disabled
                v-if="params.collectdatabase == 1"
                v-model="params.collectdatabaseName"
                style="width: 240px; margin-left: 5px"
                size="small"
                placeholder="请填写数据库名称"></el-input>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>人员情况</span>
      </div>

      <div class="editArea">
        <table>
          <tr>
            <td class="edName">单位领导：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.zbSld"
                  size="small"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">编辑人员：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.zbBjry"
                  size="small"
                  placeholder="数量"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td class="edName">除编辑以外<br />有关制作加工等<br />相关人员：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumProcess"
                  size="small"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">专职发行人员：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumIssue"
                  size="small"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">其他人员<br />（包括行政人员等）：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumOther"
                  size="small"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
          <tr>
            <td class="edName">总人数<br />（以上6项合计）：</td>
            <td class="edInp">
              <el-form-item class="chboxRight" :inline-message="true">
                <el-input-number
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.pepnumTotal"
                  size="small"
                  placeholder="数量"></el-input-number>
              </el-form-item>
              <br />
            </td>
          </tr>
        </table>
      </div>

      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea">
        <table>
          <tr>
            <td class="edName">申报人：</td>
            <td class="edInp">
              <el-input disabled v-model="declare.personnel" size="small" placeholder="请输入申报人"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">联系方式：</td>
            <td class="edInp">
              <el-input disabled v-model="declare.contact" size="small" placeholder="请输入申报人联系方式"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">申报时间：</td>
            <td class="edInp">
              <el-input v-model="params.updatedAt" size="small" :disabled="true"></el-input>
            </td>
          </tr>
        </table>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="modifyFlag" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>

<style scoped>
.chboxDiv {
  overflow: hidden;
}

.chboxLeft {
  margin-top: 13px;
  float: left;
  width: 120px;
}

.avgchbox {
  width: 120px;
  line-height: 25px;
}

.chboxRight {
  float: left;
  margin-left: 5px;
}

.chboxRightInput {
  width: 243px;
}
</style>
<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsSEt5";
import { ssSave5, ssRead5 } from "@/api/pressRole/pressSuccessive";
import UpbtnPdf from "@/views/components/uploadPdf";
export default {
  components: {
    UpbtnPdf,
  },
  data() {
    return {
      params: bsParams,
      rules: paramsRule,

      dicDats: {},
      isNot: {},
      isSub: {},
      mediaType: {},
      submiting: false,
      layDasion: 1,
      declare: {
        personnel: "",
        contact: "",
      },

      pubStatus: 0,

      modifyFlag: false,
    };
  },

  watch: {},
  methods: {
    editSave: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId; // *publicationOrganizationMaterial的主键
          this.params.materialCode = this.$route.query.mtcode;
          if (!this.declare.personnel) {
            this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!this.declare.contact || this.declare.contact == "") {
            this.$message.error("申报人联系方式必填");
            return;
          }

          // !出版物基本信息保存
          ssSave5({
            data: this.params,
            organizationPersonnel: this.declare,
            // plxdzPublication: this.params,
            // organizationPersonnel: this.declare,
          })
            .then((response) => {
              console.log("response=", JSON.stringify(response));
              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.submiting = false;
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });

                this.goBack();
              }
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    dictInit: function () {
      // let nameArr = ['C026', 'C014', 'C012', 'C025', 'C018'];
      // let newPromise = this.$store.dispatch('dictUpdate', {
      //   codeArr: nameArr,
      //   type: 'arr'
      // });
      // newPromise.then(result => {
      //   this.dicDats = result;
      //   this.isNot = this.$store.getters.dictionary['C018'];
      //   this.isSub = this.$store.getters.dictionary['C012'];
      //   this.mediaType = this.$store.getters.dictionary['C025'];
      //   for (let key in this.isNot) {
      //     if (this.isNot[key] == '是') {
      //       // this.params.isIndependentLP = key;// !是否独立法人，这个页面应该不需要
      //     } else if (this.isNot[key] == '否') {
      //       this.params.isSampleDelivery = key;
      //     }
      //   }
      //   if (this.$route.query.pgress == 2) {
      //     // this.tabReEdit();
      //   }
      // });
    },

    // !读取信息
    tabReEdit: function () {
      console.log("tabReEdit...");
      let vm = this;
      ssRead5({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
        judgeModify: true,
      }).then((response) => {
        vm.params = response.plxdzQuestionnaire;

        this.declare.contact = response.pOrganizationPersonnel.contact;
        this.declare.personnel = response.pOrganizationPersonnel.personnel;
        this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;

        this.modifyFlag = response.modifyFlag;
        console.log("modifyFlag=", this.modifyFlag);
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },
  created: function () {
    this.dictInit();
    // if (this.$route.query.pgress == 2) {
    console.log("我进来了");
    this.tabReEdit();
    // }
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.ssTab1E {
  margin-top: 0;

  .edInp .el-input-number {
    width: 300px;
  }

  .el-textarea {
    width: 450px;
  }

  .areaTime .el-form-item {
    display: inline-block;
    vertical-align: middle;
  }

  .tips {
    margin-left: 12px;
  }
}

.el-date-editor {
  border-radius: 0;
}

.table1 .edInp .el-input-number {
  width: 300px;
}

.tabCage .editArea table .edInp .el-input {
  width: auto;
}

.tabCage .editArea table .edName {
  width: 160px;
}

.suffixTitle {
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// ssTab5.vue?dcc0d838